import { handleError, handleResponse } from '@/services/api/utils/response.js'
import { getEnvAndDex } from '@/utils/get-env-and-dex.js'
import axios from 'axios'

// Standalone: bundle calls /api/* and setupProxy.js (dev) or index.js (prod)
// forwards to admin-corev2. Shell-hosted (unified portal): bundle calls native
// /api/v1/* and the CloudFront /api/* behaviour routes to admin-corev2 by the
// X-Request-From: admin header (Lambda@Edge switch). Keep /v1 in the shell base
// so requests land on admin-corev2's main router (mounted at /api/v1) and skip
// its legacy /api/* catch-all 307 redirect.
const BASE_URL = process.env.REACT_APP_SHELL_HOSTED === 'true' ? '/api/v1' : '/api'

const { dex } = getEnvAndDex()

axios.defaults.timeout = 30000;
axios.defaults.headers.common['dex'] = dex;
// Surface routing header for the unified-portal /api/* switch (admin-ui only ever
// talks to admin-corev2). Inert in standalone/legacy mode. See backend-integration-plan.md.
axios.defaults.headers.common['X-Request-From'] = 'admin';

const index = (resource, option) => {
	return axios
		.get(`${BASE_URL}/${resource}`, option)
		.then(handleResponse)
		.catch(handleError);
}

const findOne = (resource, id, option) => {
	return axios
		.get(`${BASE_URL}/${resource}/${id}`, option)
		.then(handleResponse)
		.catch(handleError);
}

const findAll = (resource, params, option) => {
	return axios
		.post(`${BASE_URL}/${resource}`, params, option)
		.then(handleResponse)
		.catch(handleError);
}

const create = (resource, model, option) => {
	return axios
		.post(`${BASE_URL}/${resource}`, model, option)
		.then(handleResponse)
		.catch(handleError);
}

const update = (resource, model, option) => {
	return axios
		.put(`${BASE_URL}/${resource}`, model, option)
		.then(handleResponse)
		.catch(handleError);
}

const remove = (resource, id, option) => {
	return axios
		.delete(`${BASE_URL}/${resource}`, id, option)
		.then(handleResponse)
		.catch(handleError);
}

const upload = (resource, files) => {

    let formData = new FormData()
    formData.append('files', files)

    return axios
		.post(`${BASE_URL}/${resource}`, formData)
		.then(handleResponse)
		.catch(handleError)
}

export const apiProvider = {
	index,
	findOne,
	findAll,
	create,
	update,
	remove,
	upload,
	BASE_URL
}
